export default{
    msg:'',
    editar:{},
    lista:'',
    numero:'',
}